<template>
    <div :class="`icon-btn ${rootClass} ${selected ? `icon-btn--selected ${rootClass}--selected` : ''}`">
        <div :class="`${rootClass}__icon-wrapper icon-btn__icon-wrapper`"
             role="button"
             tabindex="0"
             @click="$emit('click')"
             @keyup.enter="$emit('click')"
             @keyup.esc="$emit('close')">
            <i :class="`fas fa-${icon} ${rootClass}__icon icon-btn__icon-wrapper`" />
        </div>
    </div>
</template>

<script>

export default {

    props: {
        rootClass: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.icon-btn {

    @include element('icon-wrapper') {
        text-align: center;
        padding: 0.2rem;
        border-radius: 50%;
        display: table;

        &:hover, &:focus {
            cursor: pointer;
        }
    }

    @include element('icon') {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    @include modifier('selected') {
        color: green;
    }
}

</style>
